import { useFormattingStore } from '@/stores/formattingStore';
import { Card } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import {
  Bold,
  Italic,
  Underline,
  List,
  ListOrdered,
  Sparkles,
  ArrowDown,
  Minus,
  Type,
} from 'lucide-react';

export function FormattingPanel() {
  const {
    applyUnicodeBold,
    applyUnicodeItalic,
    applyUnderline,
    addBulletPoints,
    addNumbering,
    addEmojiBullets,
    addLineBreaks,
    addSectionDividers,
    capitalizeText,
  } = useFormattingStore();

  return (
    <Card>
      <h3 className="text-lg font-serif font-medium mb-4">LinkedIn Formatting</h3>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        <Button variant="secondary" onClick={applyUnicodeBold} className="justify-start gap-2">
          <Bold className="w-4 h-4" /> 𝐁𝐨𝐥𝐝
        </Button>
        <Button variant="secondary" onClick={applyUnicodeItalic} className="justify-start gap-2">
          <Italic className="w-4 h-4" /> 𝘐𝘵𝘢𝘭𝘪𝘤
        </Button>
        <Button variant="secondary" onClick={applyUnderline} className="justify-start gap-2">
          <Underline className="w-4 h-4" /> U̲n̲d̲e̲r̲l̲i̲n̲e̲
        </Button>

        <Button variant="secondary" onClick={addBulletPoints} className="justify-start gap-2">
          <List className="w-4 h-4" /> Bullets
        </Button>
        <Button variant="secondary" onClick={addNumbering} className="justify-start gap-2">
          <ListOrdered className="w-4 h-4" /> Numbers
        </Button>
        <Button variant="secondary" onClick={addEmojiBullets} className="justify-start gap-2">
          <Sparkles className="w-4 h-4" /> Emoji List
        </Button>

        <Button variant="secondary" onClick={addLineBreaks} className="justify-start gap-2">
          <ArrowDown className="w-4 h-4" /> Line Break
        </Button>
        <Button variant="secondary" onClick={addSectionDividers} className="justify-start gap-2">
          <Minus className="w-4 h-4" /> Divider
        </Button>
        <Button variant="secondary" onClick={capitalizeText} className="justify-start gap-2">
          <Type className="w-4 h-4" /> UPPERCASE
        </Button>
      </div>
    </Card>
  );
}
